import { FunctionComponent } from "react";

const SpecialOfferText: FunctionComponent = () => {
  return (
    <div className="self-stretch flex flex-col items-start justify-end py-32 px-3 box-border relative min-h-[1094px] max-w-full text-left text-29xl text-black font-racing-sans-one mq800:pt-[54px] mq800:pb-[54px] mq800:box-border mq1125:pt-[83px] mq1125:pb-[83px] mq1125:box-border">
      <img
        className="w-full h-full absolute my-0 mx-[!important] top-[0px] right-[0px] bottom-[0px] left-[0px] max-w-full overflow-hidden max-h-full"
        alt=""
        src="/vector-line.svg"
      />
      <div className="w-[1370px] h-[154px] relative bg-gray-800 overflow-hidden shrink-0 hidden max-w-full z-[1]" />
      <div className="w-[1370px] bg-gray-800 flex flex-row flex-wrap items-center justify-start relative gap-[8px] max-w-full z-[1]">
        <div className="h-[683px] w-[701px] flex flex-col items-start justify-start py-0 pr-5 pl-0 box-border max-w-full">
          <div className="self-stretch rounded-21xl [background:linear-gradient(180deg,_rgba(255,_255,_255,_0)_5.5%,_rgba(255,_255,_255,_0.7)_67.5%)] flex flex-col items-center justify-start pt-[60px] px-10 pb-40 gap-[17px] shrink-0 mq800:pt-[39px] mq800:pb-[104px] mq800:box-border mq450:pt-[25px] mq450:pb-[68px] mq450:box-border">
            <h1 className="m-0 self-stretch h-[180px] relative text-inherit tracking-[0.12em] font-normal font-inherit flex items-center mq800:text-19xl mq450:text-10xl">
              IF YOUR LOOKING FOR ADVENTURE LOOK NO FURTHER!
            </h1>
            <div className="self-stretch h-[350px] relative text-13xl font-saira flex items-center mq800:text-7xl mq450:text-lgi">
              Lorem ipsum dolor sit amet consectetur. A pharetra ut tristique
              fermentum adipiscing vestibulum suspendisse. Dignissim integer
              blandit pellentesque quis eleifend elit. Scelerisque sit cursus
              tincidunt elit donec ante. Sed posuere et habitant cursus.
            </div>
          </div>
        </div>
        <div className="h-[866px] flex-1 my-0 mx-[!important] absolute right-[0px] bottom-[-183px] flex flex-row items-start justify-end py-2.5 px-[30px] box-border max-w-full">
          <img
            className="h-[831px] flex-1 relative max-w-full overflow-hidden object-cover"
            loading="eager"
            alt=""
            src="/bikerider1@2x.png"
          />
        </div>
      </div>
    </div>
  );
};

export default SpecialOfferText;
